/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Benzin`
};

const en_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Gasoline`
};

const es_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Gasolina`
};

const fr_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Essence`
};

const it_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Benzina`
};

const nl_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Benzine`
};

const pt_itinerary__options__car_energy__gasoline = /** @type {(inputs: {}) => string} */ () => {
	return `Gasolina`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__car_energy__gasoline(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__car_energy__gasoline", locale)
	if (locale === "de") return de_itinerary__options__car_energy__gasoline(inputs)
	if (locale === "en") return en_itinerary__options__car_energy__gasoline(inputs)
	if (locale === "es") return es_itinerary__options__car_energy__gasoline(inputs)
	if (locale === "fr") return fr_itinerary__options__car_energy__gasoline(inputs)
	if (locale === "it") return it_itinerary__options__car_energy__gasoline(inputs)
	if (locale === "nl") return nl_itinerary__options__car_energy__gasoline(inputs)
	return pt_itinerary__options__car_energy__gasoline(inputs)
};